import { defineStore } from "pinia";

import emailService from "@/services/modules/emails";

import type { SendApplicationEmailModalData } from "@/models/emails";

interface UseEmailsState {
  modalData: SendApplicationEmailModalData;
}

const getDefaultState = (): UseEmailsState => ({
  modalData: {
    applications: [],
    customizations: [],
    email_addresses: [],
    templates: [],
  },
});

const useEmailsStore = defineStore("emails", {
  state: getDefaultState,
  actions: {
    async getApplicationEmailModalData(
      application_ids: string[],
      send_as_bulk = false,
      email_thread_ids?: number[]
    ) {
      const data = await emailService.getApplicationEmailModalData({
        application_ids,
        send_as_bulk,
        email_thread_ids,
      });
      this.modalData = data;
    },
  },
});

export default useEmailsStore;
